import withPrefix from '@/utils/withPrefix'

export default withPrefix('/brands/:brandId/sites/:siteId', [
  {
    path: '/translations',
    name: 'translations',
    component: () => import('./views/TranslationsList'),
    meta: {
      auth: true
    }
  }
])
